import React, { Suspense } from 'react'
import ReactDOM from 'react-dom/client'
import App from './App'
import './styles/index.css'
import './i18n'
//import { ThemeProvider } from './context/ThemeContext'
//import { AuthProvider } from './context/AuthContext'

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    {/* <ThemeProvider>
      <AuthProvider> */}
    <Suspense fallback={<div>Cargando...</div>}>
      <App />
    </Suspense>
    {/* </AuthProvider>
    </ThemeProvider> */}
  </React.StrictMode>
)
